import { render, staticRenderFns } from "./invoices-summary-v2.vue?vue&type=template&id=b6532900&"
import script from "./invoices-summary-v2.vue?vue&type=script&lang=js&"
export * from "./invoices-summary-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports